import Vue from 'vue'
import {
    FETCH_COST_TAGS_REQUEST,
    FETCH_COST_TAGS_SUCCESS,
    FETCH_COST_TAGS_FAILED,
    FETCH_COST_TAGS_CATEGORY_REQUEST,
    FETCH_COST_TAGS_CATEGORY_SUCCESS,
    FETCH_COST_TAGS_CATEGORY_FAILED,
    FETCH_COST_TAGS_RESOURCEID_REQUEST,
    FETCH_COST_TAGS_RESOURCEID_SUCCESS,
    FETCH_COST_TAGS_RESOURCEID_FAILED,
    /** Tags */
    FETCH_TAGS_ALL_REQUEST,
    FETCH_TAGS_ALL_SUCCESS,
    FETCH_TAGS_ALL_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_COST_TAGS_REQUEST]: state => {
        state.status.costTags = 'loading'
    },
    [FETCH_COST_TAGS_SUCCESS]: (state, { data, status }) => {
        state.status.costTags = status
        state.dailyTagValues = (data && data.dailyTagValues) || []
        state.tagValues = (data && data.tagValues) || []
        state.treeData = (data && JSON.parse(JSON.stringify(data.tagValues))) || []
        state.tags = data && data.tagValues && data && data.tagValues.length ? data && data.tagValues.map(item => item.tagValue) : []
    },
    [FETCH_COST_TAGS_FAILED]: (state, error) => {
        state.status.costTags = 'error'
    },
    [FETCH_COST_TAGS_CATEGORY_REQUEST]: state => {
        state.status.costTagsCategory = 'loading'
    },
    [FETCH_COST_TAGS_CATEGORY_SUCCESS]: (state, { data, status, index }) => {
        state.status.costTagsCategory = status
        Vue.set(state.treeData[index], 'children', data)
        Vue.set(state.treeData[index], 'showChildren', !state.treeData[index].showChildren)
    },
    [FETCH_COST_TAGS_CATEGORY_FAILED]: state => {
        state.status.costTagsCategory = 'error'
    },
    [FETCH_COST_TAGS_RESOURCEID_REQUEST]: state => {
        state.status.costTagsResourceId = 'loading'
    },
    [FETCH_COST_TAGS_RESOURCEID_SUCCESS]: (state, { data, index, rootIndex, status }) => {
        state.status.costTagsResourceId = status
        Vue.set(state.treeData[rootIndex].children[index], 'children', data)
        Vue.set(state.treeData[rootIndex].children[index], 'showChildren', !state.treeData[rootIndex].children[index].showChildren)
    },
    [FETCH_COST_TAGS_RESOURCEID_FAILED]: (state, error) => {
        state.status.costTagsResourceId = 'error'
    },
    /** Tags */
    [FETCH_TAGS_ALL_REQUEST]: state => {
        state.status.tags = 'loading'
    },
    [FETCH_TAGS_ALL_SUCCESS]: (state, { data }) => {
        state.status.tags = 'success'
        state.availableTags = data.sort((a, b) => a > b ? 1 : -1)
    },
    [FETCH_TAGS_ALL_FAILED]: (state, error) => {
        state.status.tags = 'error'
    }
}

export default mutations
